import Vue from 'vue'
import App from './App.vue'

import Axios from 'axios'
import VueRouter from 'vue-router'

import { routes } from './router'
import { store } from './store'

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'hash'
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js